import { useMutation } from 'react-query';
import { useRelayEnvironment } from 'react-relay/hooks';

import { commitLocalUpdate } from 'relay-runtime';
import { makeResourceKeys } from 'requests/resources/makeResources/makeResourcesKeys';
import useInvalidateStores from 'requests/resources/useInvalidateStores';

import axiosClient from '@lib/utils/axiosClient';

import { toGlobalId } from 'services/relayService';

import { Appointment } from '../types';

type Data = string;
type Response = Appointment;

const keys = makeResourceKeys('appointments');

const mutationFn = async (id: Data) => {
  const response = await axiosClient.put(`/appointments/${id}/confirm`);
  return response.data as Response;
};

export default function useAppointmentConfirm() {
  const invalidateStores = useInvalidateStores();
  const environment = useRelayEnvironment();

  const mutation = useMutation(mutationFn, {
    onSuccess: (data) => {
      invalidateStores(keys.$entityId(data._id), 'Appointment');

      commitLocalUpdate(environment, (store) => {
        const record = store.get(toGlobalId('Appointment', data._id));
        if (record) {
          record.setValue(data.status, 'status');
        }
      });
    },
  });

  return mutation;
}
